<template>
  <div
    class="fixed top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center"
    style="background: rgba(0, 0, 0, 0.4)"
    v-if="state.open"
  >
    <div class="bg-white rounded shadow p-6 border border-gray-100 w-full max-w-md mx-4">
      <p class="text-lg font-medium text-primary mb-4">Downloading Form Templates</p>

      <div class="mb-2 flex justify-between text-sm text-text">
        <span>{{ state.currentLabel || "Preparing…" }}</span>
        <span>{{ state.current }} of {{ state.total }} ({{ percentage }}%)</span>
      </div>

      <div class="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
        <div
          class="bg-primary h-3 rounded-full transition-all duration-300"
          :style="{ width: percentage + '%' }"
        ></div>
      </div>

      <p class="text-xs text-gray-400 mt-3 text-center" v-if="state.current < state.total">
        Please wait while files are downloaded…
      </p>
      <p class="text-xs text-green-600 mt-3 text-center font-medium" v-else-if="state.total > 0">
        All downloads complete.
      </p>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed } from "vue";

const state = reactive({
  open: false,
  current: 0,
  total: 0,
  currentLabel: "",
});

const percentage = computed(() => {
  if (state.total === 0) return 0;
  return Math.round((state.current / state.total) * 100);
});

function open(total = 0) {
  state.current = 0;
  state.total = total;
  state.currentLabel = "";
  state.open = true;
}

function setProgress(current, total, label = "") {
  state.current = current;
  state.total = total;
  state.currentLabel = label;
}

function close() {
  state.open = false;
}

defineExpose({ open, setProgress, close });
</script>
